// src/pages/CareersPage.jsx
import { FaBriefcase, FaMapPin, FaClock, FaEnvelope, FaUsers, FaAward, FaRocket } from 'react-icons/fa';
import Layout, { useLanguage } from '../components/Layout';

export default function CareersPage() {
  const { t } = useLanguage();

  const jobOpenings = [
    {
      title: t('careers.job1.title') || 'Network Engineer',
      type: t('careers.job1.type') || 'Full Time',
      location: 'Kisumu',
      description: t('careers.job1.description') || 'Manage and maintain our fixed wireless network infrastructure. Ensure optimal performance and reliability.'
    },
    {
      title: t('careers.job2.title') || 'Customer Support Specialist',
      type: t('careers.job2.type') || 'Full Time',
      location: 'Kisumu',
      description: t('careers.job2.description') || 'Provide excellent customer service and technical support to our growing customer base.'
    },
    {
      title: t('careers.job3.title') || 'Sales Representative',
      type: t('careers.job3.type') || 'Full Time',
      location: 'Kisumu',
      description: t('careers.job3.description') || 'Drive sales and expand our customer base in Kisumu region. Build relationships with potential clients.'
    },
    {
      title: t('careers.job4.title') || 'Installation Technician',
      type: t('careers.job4.type') || 'Full Time',
      location: 'Kisumu',
      description: t('careers.job4.description') || 'Install and set up internet equipment for new customers. Provide on-site technical support.'
    }
  ];

  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>{t('careers.title') || 'Careers at Nexcom'}</h1>
          <p className="page-subtitle">
            {t('careers.subtitle') || 'Join our team and help connect Kenya to the future'}
          </p>

          <div className="careers-intro">
            <div className="careers-badge">
              <FaBriefcase className="careers-icon" />
              <span>{t('careers.badge') || 'Join our growing team'}</span>
            </div>
            <p>
              {t('careers.intro') || "At Nexcom, we're passionate about providing reliable internet connectivity to homes and businesses across Kenya. We're looking for talented individuals who share our vision and want to make a difference."}
            </p>
            <div className="careers-values">
              <span><FaUsers /> {t('careers.value1') || 'Teamwork'}</span>
              <span><FaRocket /> {t('careers.value2') || 'Innovation'}</span>
              <span><FaAward /> {t('careers.value3') || 'Excellence'}</span>
            </div>
          </div>

          <div className="job-listings">
            <h2>{t('careers.openings') || 'Current Openings'}</h2>
            {jobOpenings.map((job, index) => (
              <div key={index} className="job-card">
                <div className="job-header">
                  <h3>{job.title}</h3>
                  <span className="job-type">{job.type}</span>
                </div>
                <div className="job-meta">
                  <span><FaMapPin /> {job.location}</span>
                  <span><FaClock /> {t('careers.start') || 'Immediate Start'}</span>
                </div>
                <p className="job-description">{job.description}</p>
                <button className="apply-btn">
                  <FaEnvelope /> {t('careers.apply') || 'Apply Now'}
                </button>
              </div>
            ))}
          </div>

          <div className="careers-cta">
            <h3>{t('careers.ctaTitle') || "Don't see a role that fits?"}</h3>
            <p>{t('careers.ctaText') || "We're always looking for talented people. Send us your CV."}</p>
            <a href="mailto:careers@nexcom.ke" className="cta-button-page">
              {t('careers.ctaButton') || 'Send Your CV'}
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}